import useRPS from 'react-promise-suspense'

export const usePromiseSuspense = useRPS
